export const SHOW_ALERT_MODAL = 'SHOW_ALERT_MODAL';
export const HIDE_ALERT_MODAL = 'HIDE_ALERT_MODAL';

export const showAlertModal = payload => ({
  type: SHOW_ALERT_MODAL,
  payload,
});

export const hideAlertModal = () => ({
  type: HIDE_ALERT_MODAL,
});

const INITIAL_STATE = {
  visible: false,
  title: '',
  description: '',
  closeButtonText: 'Close',
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SHOW_ALERT_MODAL:
      return { ...state, ...payload, visible: true };

    case HIDE_ALERT_MODAL:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export const getAlertModalVisible = state => state.alertModal.visible;
export const getAlertModalProps = state => state.alertModal;



// WEBPACK FOOTER //
// ./app/redux/alertModal.js